import * as React from "react";
import { BrowserRouter, Route, Link, Switch, Redirect, withRouter } from "react-router-dom";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { UserModel } from '../../../models/user/userModel';
import UserService from '../../../services/userService';
import AuthService from '../../../services/authService';
import Growl from '../../../common/components/alertMessage/growl';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import { connect } from 'react-redux';
import * as actionTypes from '../../../store/actionTypes';
import FileSaver from 'file-saver';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faDownload, faFile } from '@fortawesome/free-solid-svg-icons';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

interface IProps {
  history: any,
  onUserLogout: any,
  lang: string
}

interface IState {
  isLoading: boolean;
  user: UserModel;
  isVisibleConfirmDialog: boolean;
}

class UserInformationTab extends React.Component<IProps, IState> {

  userService = new UserService();
  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      user: new UserModel(),
      isVisibleConfirmDialog: false
    };
  }

  componentDidMount() {
  }

  handleGetAccounInfoButton = (event, type) => {
    event.preventDefault();

    this.setState({
      isLoading: true
    });

    this.userService.getAccountInfo(this.props.lang).then(
      (data: any) => {
        this.setState({
          isLoading: false
        });
        if (data) {
          let res = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
          if (type == 'view') {
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(res);
            }
            else {
              var url = window.URL.createObjectURL(res);
              window.open(url);
            }
          } else {
            FileSaver.saveAs(res, "UserInformation.json");
          }
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleDeleteAccountButton = event => {
    event.preventDefault();
    this.setState({
      isVisibleConfirmDialog: true
    });
  }

  deleleteAccount = () => {
    this.setState({
      isLoading: true
    });

    this.userService.deleteAccountPermanently().then(
      (data: any) => {
        if (data) {
          this.setState({
            isLoading: false
          });
          this.authService.logout();
          setTimeout(() => {
            this.props.onUserLogout();
            this.props.history.push(`/`);
          });
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }


  public render() {
    const { isLoading } = this.state;
    const userId = this.authService.getUserId();

    return (
      <div>
        {isLoading ? <Spinner /> : null}

        <Growl ref={(el) => this.growl = el} />

        <div>
          <div style={{ margin: '20px 0' }}>
            <Card>
              <CardContent>
                <h3>
                  {Translate('Download Your Information')}
                </h3>
                <div>
                  {Translate('DownloadYourInformationDescription')}
                </div>
              </CardContent>
              <CardActions>
                <div style={{ textAlign: "right", padding: '0 8px', width: '100%' }}>
                  <Button variant="contained" size="small" color="primary" onClick={e => this.handleGetAccounInfoButton(e, 'view')} style={{ marginRight: '10px' }}>
                    <FontAwesomeIcon icon={faFile} style={{ marginRight: '5px' }} />
                    {Translate('View')}
                  </Button>
                  <Button variant="contained" size="small" color="default" onClick={e => this.handleGetAccounInfoButton(e, 'download')}>
                    <FontAwesomeIcon icon={faDownload} style={{ marginRight: '5px' }} />
                    {Translate('Download')}
                  </Button>
                </div>
              </CardActions>
            </Card>

          </div>

          <div style={{ margin: '20px 0' }}>
            <Card>
              <CardContent>
                <h3>
                  {Translate('Permanently Delete Account')}
                </h3>
                <div>
                  {Translate('DeleteAccountPermanentlyDescription')}
                </div>
              </CardContent>
              <CardActions>
                <div style={{ textAlign: "right", padding: '0 8px', width: '100%' }}>
                  <Button variant="contained" size="small" color="secondary" onClick={this.handleDeleteAccountButton}>
                    <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                    {Translate('Delete Account')}
                  </Button>
                </div>
              </CardActions>
            </Card>

            {/* <Card title={Translate('Permanently Delete Account')}>
              <div>
                {Translate('DeleteAccountPermanentlyDescription')}
              </div>
              <div style={{ padding: '10px 0' }}>
                <Button variant="contained" size="small" color="secondary" onClick={this.handleDeleteAccountButton}>
                  <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                  {Translate('Delete Account')}
                </Button>
              </div>
            </Card> */}
          </div>
        </div>

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.setState({ isVisibleConfirmDialog: false }); this.deleleteAccount() }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          {Translate('Are you sure that you want to delete your Account permanently?')}
        </ConfirmDialog>

      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onUserLogout: () => dispatch({ type: actionTypes.USER_LOGOUT })
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default withRouter(connect(mapsStateToProps, mapDispatchToProps)(UserInformationTab));